



























































import Vue from "vue";

export default Vue.extend({
  name: "ExperienceMobile",

  data: () => ({
    softway: [
      {
        description: "experiences.softway.planningpoker",
        details: [
          "details.vuejs",
          "details.nestjs",
          "details.websockets",
          "details.typescript",
          "details.openshift"
        ]
      },
      {
        description: "experiences.softway.dexther",
        details: [
          "details.java",
          "details.spring",
          "details.maven",
          "details.hibernate",
          "details.quarkus",
          "details.openshift",
          "details.scrummaster",
          "details.english",
          "details.scrum"
        ]
      },
      {
        description: "experiences.softway.pmm",
        details: [
          "details.vuejs",
          "details.mongodb",
          "details.typescript",
          "details.nestjs",
          "details.openshift",
          "details.ux",
          "details.ds",
          "details.scrummaster",
          "details.english",
          "details.scrum"
        ]
      },
      {
        description: "experiences.softway.injectable",
        details: [
          "details.java",
          "details.jsp",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.angularjs",
          "details.maven",
          "details.rational",
          "details.scrum"
        ]
      },
      {
        description: "experiences.softway.offline",
        details: [
          "details.couchbase",
          "details.couchbasemobile",
          "details.angular",
          "details.java",
          "details.openshift",
          "details.springboot",
          "details.scrum",
          "details.git"
        ]
      }
    ],
    thales: [
      {
        title: "experiences.thales.edf.title",
        description: "experiences.thales.edf.description",
        details: [
          "details.angular",
          "details.typescript",
          "details.cordova",
          "details.yeoman",
          "details.java",
          "details.git",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.boiron.title",
        description: "experiences.thales.boiron.description",
        details: [
          "details.java",
          "details.swing",
          "details.angularjs",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.biomerieux.title",
        description: "experiences.thales.biomerieux.description",
        details: [
          "details.java",
          "details.swing",
          "details.gwt",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.sncf.title",
        description: "experiences.thales.sncf.description",
        details: [
          "details.java",
          "details.mdm",
          "details.xsd",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.orange.title",
        description: "experiences.thales.orange.description",
        details: [
          "details.java",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.wicket",
          "details.ajax",
          "details.scrum"
        ]
      }
    ]
  })
});
